export const ENFORCEMENT_BOTTOM_DRAWER = 'ENFORCEMENT_BOTTOM_DRAWER';
